import React from 'react';
import style from './App.less';
import pic1 from "./images/pic1.png"
import pic2 from "./images/pic2.png"
import pic3 from "./images/pic3.png"
import pic4 from "./images/pic4.png"
import pic5 from "./images/pic5.png"
import pic6 from "./images/pic6.png"
import pic7 from "./images/pic7.png"
import pic8 from "./images/pic8.png"
import pic9 from "./images/pic9.png"
// import pic10 from "./images/pic10.png"
import pic11 from "./images/pic11.png"
import pic12 from "./images/pic12.png"
import pic13 from "./images/pic13.png"
import pic14 from "./images/pic14.png"
import pic15 from "./images/pic15.png"
class introduce extends React.PureComponent {
    state={
        showloading:true
    }
    componentDidMount(){
        setTimeout(()=>{
            this.setState({
                showloading:false
            })
        },400)
        document.title="多联机WIFI盒子使用说明书"
    }
    render(){
        return (
               <div>
                  {this.state.showloading&&<div className={style.white}></div>}
                   <div className={style.introduceBox}>
                        <p className={style.top}>(本WiFi盒子适用一套多联机系统)</p>
                        <div className={style.show}>
                            <p>产品示意图</p>
                            <div className={style.images}><img src={pic1} alt=""/></div>
                            <p>1 电源接口：连接配套12V的电源适配器</p> 
                            <p>2 CAN接口：与空调系统进行数据通迅 </p>
                            <p>3 复位按钮：长按5S复位进行配</p>
                        </div>

                        <div className={style.first}>
                            <span className={style.title}>一、工程安装</span>
                            <div className={style.images}><img src={pic2} alt=""/></div>
                        </div>

                        <div className={style.second}>
                            <span className={style.title2}>二、绑定新设备</span>
                            <h3>下载安装 T 智控 APP </h3>
                            <p>扫描 Wifi 模块或者纸质说明书上的二维码下载最新APP软件 </p>
                            <br/>
                            <b>使用注意事项</b>
                            <p> 1、手机上必须安装 T 智控 APP 才能使用本机 WIFI 功能。 </p>
                            <p> 2、该软件兼容 2.1 以上的所有 android 版本。 </p>
                            <p> 3、该软件兼容 5.0 以上所有的 ios 版本。 </p>
                            <p> 4、本操作界面为通用版本，部分空调并没有本界面上的部分功能，请参考所购买空调的实际 功能操作。</p>
                            <p> 5、如果路由器损坏，更换路由器名称和密码时，需将 Wifi 盒子进行复位，清除手机中原有空调列表，然后操作手机重新配置空调。</p> 
                            <p> 6、本说明书使用的图片仅供参考，具体请以实物为主。 </p>
                        </div>

                        <div className={style.third}>
                            <span className={style.title}>三、空调配网</span>
                            <p>第一步：确保空调上电以及WIFI盒子连接上适配器并通电。</p>
                            <br/>
                            <div className={style.images}><img src={pic3} alt=""/></div>
                            <br/>
                            <p>第二步：复位WIFI模块（方法1：长按WIFI模块上的复位按钮5S 方法2：用TCL遥控器对准WIFI模块面板6S内连续按“睡眠键”4 次），WIFI模块进入重置状态，面板蓝色指示灯快闪。</p>
                            <br/>
                            <div className={style.images}><img src={pic4} alt=""/></div>
                            <p  className={style.notice}>注意!! WIFI盒子如果一直处于复位状态，10分钟内没有配网动作，盒子会进入休眠状态，此时蓝色指示灯常亮，不能进行配网，如要配网需重新进行复位操作。</p>
                            <p>第三步：打开手机选择 WIFI 连接，并与家庭路由器连接。打开T智控APP，在初始界面点击下方“立即注册”，填写手机号，获取验证码进行注册。 
                                <br/>注册成功返回登陆界面进行登陆。</p>
                                <br/><div className={style.images}><img src={pic5} alt=""/></div>
                                <br/><p>第四步：登陆成功后进入“我的设备”界面，按以下步骤添加设备。</p>
                            <p>步骤1：点击“我的设备”右上角 “+”按钮。</p>
                            <p>步骤2：注意此时Wifi 盒子应处于复位状态，点击下一步。</p>
                            <br/>
                            <div className={style.images}>
                                <img src={pic6} alt=""/>
                                <p className={style.step}> 
                                    <span>步骤1</span>
                                    <span>步骤2</span>
                                </p>
                            </div>

                            <br/><p>步骤3：输入当前路由器密码，点击下一 步。 </p>
                            <p>步骤4：等待添加成功，注意!!!如果连接失败请检查网络是否正常或者密码输入有误。此时可点击Wifi盒子名称进行修改: 例“1#中央空调” 修改后点击完成。</p>
                            <br/>
                            <div className={style.images}>
                                <img src={pic7} alt=""/>
                                <p className={style.step}> 
                                    <span>步骤3</span>
                                    <span>步骤4</span>
                                </p>
                            </div>
                            <br/><p>步骤5：此时进入我的设备界面，Wifi盒子上显示0台设备0台在线， 点击此Wifi盒子名称进入下一步。 </p>
                            <p>步骤6：进入1#中央空调Wifi盒子页面， 点击右上角“+”按钮搜索设备。</p>
                            <br/>
                            <div className={style.images}>
                                <img src={pic8} alt=""/>
                                <p className={style.step}> 
                                    <span>步骤5</span>
                                    <span>步骤6</span>
                                </p>
                            </div>
                            <br/><p>步骤7：选中要添加的子设备，点击下一步。  </p>
                            <p>步骤8：提示添加成功，此时可以修改空调名称，例如三台内机分别命名为“房间1”、“房间2”、“房间3”，修改完成后点击完成。</p>
                            <br/>
                            <div className={style.images}>
                                <img src={pic9} alt=""/>
                                <p className={style.step}> 
                                    <span>步骤7</span>
                                    <span>步骤8</span>
                                </p>
                            </div>
                            <br/><p>以上步骤完成后，绑定设备成功。</p>
                        </div>
                        {/* 4 */}
                        <div className={style.forth}>
                            <span className={style.title2}>四、空调控制</span>
                            <h3>一、 WIFI模块与空调名称修改</h3>
                            <br/><div className={style.images}><img src={pic12} alt=""/></div> <br/>
                            <p>名称修改、设备或分享帐号删除均采用类似方法</p>
                            <h3>二、 组控功能</h3>
                            <p>1、点击下方“定义分组”选项，然后点击右上角“+”按钮 </p>
                            <p>2、输入分组名称，点击下一步</p>
                            <br/><div className={style.images}><img src={pic13} alt=""/></div> <br/>
                            <p>3、选择添加空调所在的WIFI模块，点击下一步  </p>
                            <p>4、选择分组的空调，然后点击完成，即可实现多台空调同时控制</p>
                            <br/><div className={style.images}><img src={pic14} alt=""/></div> <br/>

                            <h3>三、 设备分享功能</h3>
                            <p>当房屋主人手机完成配网功能后，可将帐号内的所有空调设备分享 给家人，让家人实现控制。</p>
                            <p>1、点击下方“我的”选项，选择“设备分享”功能</p>
                            <br/><div className={style.images}><img src={pic15} alt=""/></div> <br/>
                            <p>2、点击右上角的二维码按钮可扫描其它人共享的二维码图片 </p>
                            <p>3、分享设备：点击可生成二维码图片分享给其它人 </p>
                            <p>4、分享成员：点击可查看被分享人员的帐号</p>

                            <h3>四、 远程控制模式 </h3>
                            <p> 当手机没有连接空调所在的无线路由，而是使用移动网络或者其它 无线路由时，即为远程控制状态，此时只需保证空调所在的无线路 由能够连接互联网，就可在世界各地对空调进行控制。 </p>
                            <br/><div className={style.images}><img src={pic11} alt=""/></div> <br/>
                        </div>




                        <div className={style.fifth}>
                            <span className={style.title}>五、WIFI复位</span>
                            <p> 已经配置过的空调无法正常用手机控制时，可以选择复位功能后重 新配置。  </p>
                            <p> 方法一：在Wifi模块上找到复位按钮，长按复位键5秒，Wifi模块 面板蓝色指示灯快闪则复位成功。   </p>
                            <p> 方法二：用TCL遥控器对准WIFI模块面板6S内连续按“睡眠键”4 次，Wifi模块面板蓝色指示灯快闪则复位成功。   </p>
                        </div>

                        <div className={style.sixth}>
                            <span className={style.title2}>六、故障分析</span><br/>
                            <br/><p><b>现象描述:</b></p>
                            <p> 空调无法配置成功 </p>
                            <p><b> 原因分析:</b></p>
                            <p>  1. 手机上输入的 WIFI 名称和密码是否正确； <br/>
                                 2. WiFi 盒子是否在配置状态；  <br/>
                                 3. 手机或路由器是否有设置防火墙等限制；  <br/>
                                 4. 路由器工作是否正常；  <br/>
                                 5. WiFi 盒子和路由器以及手机是否在合理信号范围内。
                            </p>

                            <br/><p><b>现象描述:</b></p>
                            <p> 设备不在线  </p>
                            <p><b> 原因分析:</b></p>  
                            <p>  1. 空调断电了； <br/>
                                 2. 路由器断电了；  <br/>
                                 3. 空调无法连接到 WiFi 盒子(通迅线断开)；  <br/>
                                 4. WiFi 盒子无法通过路由器连接到外网(远程模式下) ；  <br/>
                                 5. 手机没有连接到路由器(本地模式下)；<br/>
                                 6. 手机无法连接到外网(远程模式下)。
                            </p>

                            <br/><p><b>现象描述:</b></p>
                            <p> 控制延时响应   </p>
                            <p><b> 原因分析:</b></p>  
                            <p> 一般在刚进入软件就直接点击空调设备这一操作时出现，请视网络 情况等待几秒再尝试进行操作。</p>
                        </div>

                        <div className={style.seventh}>
                            <span className={style.title}>七、显示说明</span>
                            <div className={style.tableBox}>
                            
                            <table>
                            <tbody>
                                <tr>
                                    <td className={style.tdOne}>黄色LED</td>
                                    <td className={style.tdTwo}>
                                        1、电源指示灯，上电后常亮<br/>
                                        2、连续20S接收不到空调电控板信号---快闪（200ms闪烁一次），请及时报修。
                                    </td>
                                </tr>
                                <tr>
                                    <td  className={style.tdThree}>蓝色LED</td>
                                    <td className={style.tdFour}>
                                         配网指示灯<br/>
                                        1、WIFI模块复位后进入待配网状态---快闪（200ms闪烁一次）<br/>
                                        2、配网时正在连接路由器---较快闪（500ms闪烁一次）<br/>
                                        3、配网成功，已连上云服务器---慢闪（3S闪烁一次）<br/>
                                        4、Wifi模块处于复位状态，10分钟内没有配网动作，指示灯常亮
                                        （下次配网需重新复位）
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                   </div>
               </div>
        )
    }
}
export default introduce;